/* Component Dependencies */
var hotelQuickViewTemplate = require('templates/hotelQuickView.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
  type: 'hotelQuickView',
  template: {
    'hotelQuickView': hotelQuickViewTemplate
  },
  bindEvents: function() {
    var _self = this;
    this.$el.find(".js-toggle-header").on('click keydown',function(e){
      if(e.type == "click" || (e.type == "keydown" && e.which === 13)) {
        _self.toggleHandler(e);
      }
    });
    _self.setSearchGridViewType();	
  },
  toggleHandler: function(e) {
    var toggleContainer = $(e.currentTarget);
    toggleContainer.toggleClass('open');
    if (toggleContainer.hasClass('open')) {
      toggleContainer.find('.accordion-section').slideDown('fast', function() {
          $(this).css('overflow', 'visible');
      });
    } else {
      toggleContainer.find('.accordion-section').slideUp('fast');
    }
    toggleContainer.find(".js-toggle-carat").toggleClass("t-icon-arrow-up").toggleClass("t-icon-arrow-down");
  },
  /**
   * set search view type when compare
   */
  setSearchGridViewType: function _setSearchGridViewType() {
    var viewType = $('.tile-property-records-toolbar a.is-active', window.parent.document).attr('data-view');
    if(viewType !== undefined && viewType === "compare"){
       $('.mfp-content .rate-container div.m-button-primary').click(function(){
	if (window.sessionStorage) {
            sessionStorage.setItem('comparePropertyClick', true);
	}
      });
    }
  }
});
